// extracted by mini-css-extract-plugin
export default {"root":"ToolBar_root__E7XGg","section":"ToolBar_section__N4vTs"};